import { Navigate, Route, Routes } from "react-router-dom";
import { NotificationProvider } from "../components/ui/NotificationProvider";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import { AuthProvider } from "../context/AuthContext";
import PagesManager from "../features/cms/pages/PagesManager";
import ArticlesManager from "../features/cms/articles/ArticlesManager";
import ProjectsManager from "../features/cms/projects/ProjectsManager";
import PositionsManager from "../features/cms/positions/PositionsManager";
import ApplicationsManager from "../features/cms/applications/ApplicationsManager";
import ContactMessagesManager from "../features/cms/contactMessages/ContactMessagesManager";
import QuoteRequestsManager from "../features/cms/quoteRequests/QuoteRequestsManager";
import HostingOrdersManager from "../features/cms/hostingOrders/HostingOrdersManager";
import ServicePagesManager from "../features/cms/services/ServicePagesManager";
import IndustryPagesManager from "../features/cms/industries/IndustryPagesManager";
import SectionEditor from "../features/cms/sections/SectionEditor";
import SectionsManager from "../features/cms/sections/SectionsManager";
import ProtectedRoute from "../routes/ProtectedRoute";
import CmsLogin from "./CmsLogin";

export default function CmsAdminApp() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route index element={<CmsLogin />} />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="services" replace />} />
            <Route path="services" element={<ServicePagesManager />} />
            <Route path="industries" element={<IndustryPagesManager />} />
            <Route path="pages" element={<PagesManager />} />
            <Route path="articles" element={<ArticlesManager />} />
            <Route path="projects" element={<ProjectsManager />} />
            <Route path="positions" element={<PositionsManager />} />
            <Route path="applications" element={<ApplicationsManager />} />
            <Route path="contact-messages" element={<ContactMessagesManager />} />
            <Route path="quote-requests" element={<QuoteRequestsManager />} />
            <Route path="hosting-orders" element={<HostingOrdersManager />} />
            <Route path="pages/:pageId/sections" element={<SectionsManager />} />
            <Route
              path="pages/:pageId/sections/:sectionId"
              element={<SectionEditor />}
            />
          </Route>
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  );
}
